import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { TelSysTypes } from '../../../NonReact/constants/TelephonyServerTypes'
import { INTEGRATION_TYPE, IntegrationType } from '../../TelSysConfiguration/Constants/Constants'

/**
 * Resolves a validation message whose licence name changes for MS Teams Business.
 *
 * Business MS Teams reuses the existing reporting access values but displays them as Historic User, Real-Time User,
 * Agent, and Manager. Validation messages therefore need the `_MSTB` language variant, while Legacy MS Teams and
 * other telephony systems must keep the existing `getWithTelSysCheck` behavior.
 *
 * @param language - Language handler used to read the validation message.
 * @param baseKey - Base validation language key.
 * @param telSysType - Current telephony system type.
 * @param integrationType - Current MS Teams integration type.
 * @returns The validation message for the current telephony system and integration type.
 */
export function getBusinessAwareValidationMessage(
    language: CLanguageHandler,
    baseKey: string,
    telSysType: Nullable<TelSysTypes>,
    integrationType: Nullable<IntegrationType>
): string {
    if (telSysType === TelSysTypes.MS_TEAMS && integrationType === INTEGRATION_TYPE.BUSINESS) {
        return language.get(`${baseKey}_MSTB`)
    }

    return language.getWithTelSysCheck(baseKey, telSysType)
}
